// Moment support
import 'moment/locale/es'

import * as Sentry from '@sentry/browser'

const { NODE_ENV } = process.env
const isProduction = NODE_ENV === 'production'

// Sentry.init() is synchronous, making it async to ensure it can be awaited
const initSentry = async () => {
  const {
    REACT_APP_SENTRY_KEY: KEY,
    REACT_APP_SENTRY_APP_ID: ID,
    REACT_APP_SENTRY_ENV: ENVIRONMENT,
    REACT_APP_SENTRY_VERSION: VERSION
  } = process.env

  if (!isProduction) {
    return
  }

  if (!KEY || !ID) {
    // eslint-disable-next-line no-console
    console.warn(
      'Sentry not initialized: Missing REACT_APP_SENTRY_KEY or REACT_APP_SENTRY_APP_ID in production environment.'
    )
    return
  }

  Sentry.init({
    beforeSend(event, hint) {
      const originalException = hint?.originalException

      if (
        originalException === 'Timeout' ||
        (originalException instanceof Error &&
          originalException.message?.match(/Non-Error promise rejection captured with value: Timeout/i))
      ) {
        return null // Known reCAPTCHA issue -- https://github.com/getsentry/sentry-javascript/issues/2514
      }

      return event
    },
    dsn: `https://${KEY}@sentry.io/${ID}`,
    environment: ENVIRONMENT,
    allowUrls: [/homebot\.rocks/, /homebotapp\.com/, /homebot\.services/],
    ignoreErrors: [
      "InvalidCharacterError: Failed to execute 'createElement' on 'Document': The tag name provided ('<IFRAME name=",
      /Loading chunk [0-9]+ failed/
    ],
    release: VERSION || 'production'
  })
}

/** Not sure why we use array here, probably to be able to init multiple services */
export const configApp = () => Promise.all([initSentry()])
